<template>
  <div class="print-view">
    <main class="pt-3">
      <div class="container-fluid">
        <b-row>
          <b-col>
            <b-button class="my-4 print-hide" variant="primary" size="lg" @click="onPrint">Print</b-button>
            <router-view></router-view>
          </b-col>
        </b-row>
        <hm-footer/>
      </div>
    </main>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PrintContainer',
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      loading: 'isLoading',
    })
  },
  methods: {
    onPrint() {
      return window.print();
    }
  }
}
</script>

<style>
.print-view {
  background-color: #fff;
}
.print-view-hide {
  /* hide on print view and from print */
    display: none;
}
@media print {
  .print-hide {
    /* hide from print */
    display: none;
  }
}
</style>